(function () {
  'use strict';
  var configNode = document.getElementById('scdjk-app-config');
  if (!configNode) return;
  var cfg = JSON.parse(configNode.textContent);
  var previous = null;
  try { previous = sessionStorage.getItem('merchfieber_fanshop'); } catch (e) {}
  if (!cfg.enabled && !(cfg.cart && previous === 'handball')) return;
  var root = document.documentElement;
  root.classList.add('scdjk-app-active');
  var standalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
  var isIOS = /iphone|ipad|ipod/i.test(window.navigator.userAgent || '');
  var isMobileViewport = window.matchMedia('(max-width: 989px)').matches;
  if (standalone) root.classList.add('scdjk-app-standalone');
  var color = document.querySelector('meta[name="theme-color"]');
  if (color) color.content = '#B02324';
  function metadata(name, value) {
    var meta = document.createElement('meta'); meta.name = name; meta.content = value; document.head.appendChild(meta);
  }
  if (cfg.cart) {
    metadata('application-name', 'SC DJK Handball');
    metadata('apple-mobile-web-app-capable', 'yes');
    metadata('apple-mobile-web-app-title', 'SC DJK Handball');
    metadata('apple-mobile-web-app-status-bar-style', 'default');
    var manifest = document.createElement('link'); manifest.rel = 'manifest'; manifest.href = cfg.manifest; manifest.crossOrigin = 'use-credentials'; document.head.appendChild(manifest);
    var icon = document.createElement('link'); icon.rel = 'apple-touch-icon'; icon.href = cfg.icon; document.head.appendChild(icon);
  }
  function url(path, hash) {
    var result = new URL(path, location.origin);
    if (cfg.preview) { result.searchParams.set('preview_theme_id', String(cfg.themeId)); result.searchParams.set('pb', '0'); }
    result.searchParams.set('scdjk_app', '1');
    if (hash) result.hash = hash;
    return result.pathname + result.search + result.hash;
  }
  var notifyStorageKey = 'scdjk_notification_preferences_v1';
  var installCtaStorageKey = 'scdjk_install_cta_dismissed_v1';
  function installCtaDismissed() {
    try { return localStorage.getItem(installCtaStorageKey) === '1'; } catch (e) { return false; }
  }
  function dismissInstallCta() {
    try { localStorage.setItem(installCtaStorageKey, '1'); } catch (e) {}
    var cta = document.getElementById('scdjk-mobile-install-cta');
    if (cta) cta.hidden = true;
  }
  var notifyTeams = ['1. Damen','2. Damen','3. Damen','wA','mA','wB','mB','wC1','wC2','wD1','wD2','mD1','mD2','wE1','wE2','mE'];
  var notifyTypes = [
    ['gameReminder','Spiel-Erinnerung'],
    ['throwOff','Anwurf jetzt'],
    ['halftime','Halbzeit'],
    ['finalScore','Endergebnis'],
    ['importantUpdates','Wichtige Spiel-/Tabellenupdates'],
    ['newProducts','Neue Fanshop-Produkte'],
    ['offers','Aktionen / Angebote'],
    ['news','Allgemeine News']
  ];
  function loadNotifyPrefs() {
    var blank = {teams:{},types:{},importantOnly:false,quietEnabled:false,quietStart:'22:00',quietEnd:'07:00'};
    notifyTeams.forEach(function (t) { blank.teams[t] = false; });
    notifyTypes.forEach(function (t) { blank.types[t[0]] = false; });
    try {
      var saved = JSON.parse(localStorage.getItem(notifyStorageKey) || 'null');
      if (saved && typeof saved === 'object') {
        if (saved.teams) Object.keys(blank.teams).forEach(function (k) { blank.teams[k] = saved.teams[k] === true; });
        if (saved.types) Object.keys(blank.types).forEach(function (k) { blank.types[k] = saved.types[k] === true; });
        blank.importantOnly = saved.importantOnly === true;
        blank.quietEnabled = saved.quietEnabled === true;
        if (/^\\d{2}:\\d{2}$/.test(saved.quietStart || '')) blank.quietStart = saved.quietStart;
        if (/^\\d{2}:\\d{2}$/.test(saved.quietEnd || '')) blank.quietEnd = saved.quietEnd;
      }
    } catch (e) {}
    return blank;
  }
  function saveNotifyPrefs(prefs) {
    try { localStorage.setItem(notifyStorageKey, JSON.stringify(prefs)); } catch (e) {}
  }
  function ensureNotifyPanel() {
    if (document.getElementById('scdjk-notify-modal')) return;
    var prefs = loadNotifyPrefs();
    var modal = document.createElement('div');
    modal.id = 'scdjk-notify-modal';
    modal.setAttribute('aria-hidden','true');
    modal.innerHTML = '<div class="scdjk-notify-backdrop" data-scdjk-notify-close></div><section class="scdjk-notify-card" role="dialog" aria-modal="true" aria-labelledby="scdjk-notify-title"><button type="button" class="scdjk-notify-close" data-scdjk-notify-close aria-label="Schließen">×</button><p class="scdjk-notify-kicker">SC DJK HANDBALL</p><h2 id="scdjk-notify-title">Benachrichtigungen</h2><p class="scdjk-notify-note">Wähle selbst aus, was dich interessiert. Standardmäßig ist alles ausgeschaltet.</p><div class="scdjk-notify-grid"><fieldset><legend>Mannschaften</legend><div id="scdjk-notify-teams" class="scdjk-notify-options"></div></fieldset><fieldset><legend>Benachrichtigungsarten</legend><div id="scdjk-notify-types" class="scdjk-notify-options"></div></fieldset></div><div class="scdjk-notify-extra"><label><input type="checkbox" data-notify-extra="importantOnly"> Nur wichtige Meldungen</label><label><input type="checkbox" data-notify-extra="quietEnabled"> Ruhezeiten aktivieren</label><div class="scdjk-quiet-times"><label>von <input type="time" data-notify-time="quietStart"></label><label>bis <input type="time" data-notify-time="quietEnd"></label></div></div><p class="scdjk-notify-status">Deine Auswahl wird auf diesem Gerät gespeichert. Echter System-Push ist in der aktuellen Shopify-Theme-Lösung noch nicht aktiviert.</p><button type="button" class="button scdjk-notify-done" data-scdjk-notify-close>Fertig</button></section>';
    document.body.appendChild(modal);
    var teamsBox = modal.querySelector('#scdjk-notify-teams');
    notifyTeams.forEach(function (name) {
      var label = document.createElement('label');
      label.innerHTML = '<input type="checkbox" data-notify-team="' + name + '"><span>' + name + '</span>';
      label.querySelector('input').checked = prefs.teams[name] === true;
      teamsBox.appendChild(label);
    });
    var typesBox = modal.querySelector('#scdjk-notify-types');
    notifyTypes.forEach(function (entry) {
      var label = document.createElement('label');
      label.innerHTML = '<input type="checkbox" data-notify-type="' + entry[0] + '"><span>' + entry[1] + '</span>';
      label.querySelector('input').checked = prefs.types[entry[0]] === true;
      typesBox.appendChild(label);
    });
    modal.querySelector('[data-notify-extra="importantOnly"]').checked = prefs.importantOnly;
    modal.querySelector('[data-notify-extra="quietEnabled"]').checked = prefs.quietEnabled;
    modal.querySelector('[data-notify-time="quietStart"]').value = prefs.quietStart;
    modal.querySelector('[data-notify-time="quietEnd"]').value = prefs.quietEnd;
    function sync() {
      var next = loadNotifyPrefs();
      modal.querySelectorAll('[data-notify-team]').forEach(function (el) { next.teams[el.dataset.notifyTeam] = el.checked; });
      modal.querySelectorAll('[data-notify-type]').forEach(function (el) { next.types[el.dataset.notifyType] = el.checked; });
      next.importantOnly = modal.querySelector('[data-notify-extra="importantOnly"]').checked;
      next.quietEnabled = modal.querySelector('[data-notify-extra="quietEnabled"]').checked;
      next.quietStart = modal.querySelector('[data-notify-time="quietStart"]').value || '22:00';
      next.quietEnd = modal.querySelector('[data-notify-time="quietEnd"]').value || '07:00';
      saveNotifyPrefs(next);
    }
    modal.addEventListener('change', sync);
    modal.querySelectorAll('[data-scdjk-notify-close]').forEach(function (el) { el.addEventListener('click', closeNotifyPanel); });
  }
  function openNotifyPanel() {
    ensureNotifyPanel();
    var modal = document.getElementById('scdjk-notify-modal');
    modal.classList.add('is-open'); modal.setAttribute('aria-hidden','false');
    document.body.classList.add('scdjk-notify-open');
  }
  function closeNotifyPanel() {
    var modal = document.getElementById('scdjk-notify-modal');
    if (!modal) return;
    modal.classList.remove('is-open'); modal.setAttribute('aria-hidden','true');
    document.body.classList.remove('scdjk-notify-open');
    if (location.hash === '#handball-benachrichtigungen' && history.replaceState) history.replaceState(null,'',location.pathname + location.search);
  }
  var pendingInstall = null;
  window.addEventListener('beforeinstallprompt', function (event) {
    if (standalone) return;
    event.preventDefault();
    pendingInstall = event;
    var button = document.getElementById('scdjk-app-install'); if (button) button.hidden = false;
    var cta = document.getElementById('scdjk-mobile-install-cta'); if (cta && !installCtaDismissed()) cta.hidden = false;
  });
  window.addEventListener('appinstalled', function () {
    pendingInstall = null;
    dismissInstallCta();
    var help = document.getElementById('scdjk-app-install-help'); if (help) help.hidden = true;
    var sheet = document.getElementById('scdjk-install-sheet'); if (sheet) sheet.classList.remove('is-open');
  });
  function ensureInstallSheet() {
    if (document.getElementById('scdjk-install-sheet')) return;
    var sheet = document.createElement('div');
    sheet.id = 'scdjk-install-sheet';
    sheet.setAttribute('aria-hidden','true');
    sheet.innerHTML = '<div class="scdjk-install-sheet-backdrop" data-scdjk-install-close></div><section class="scdjk-install-sheet-card" role="dialog" aria-modal="true" aria-labelledby="scdjk-install-title"><button type="button" class="scdjk-install-sheet-close" data-scdjk-install-close aria-label="Schließen">×</button><div class="scdjk-install-sheet-icon">📲</div><h2 id="scdjk-install-title">SC DJK Handball installieren</h2><div id="scdjk-install-sheet-text"></div><button type="button" class="button scdjk-install-sheet-done" data-scdjk-install-close data-scdjk-install-dismiss>Verstanden</button></section>';
    document.body.appendChild(sheet);
    sheet.querySelectorAll('[data-scdjk-install-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        if (el.hasAttribute('data-scdjk-install-dismiss')) dismissInstallCta();
        sheet.classList.remove('is-open');
        sheet.setAttribute('aria-hidden','true');
      });
    });
  }
  function openInstallSheet() {
    ensureInstallSheet();
    var sheet = document.getElementById('scdjk-install-sheet');
    var text = sheet.querySelector('#scdjk-install-sheet-text');
    if (isIOS) {
      text.innerHTML = '<p>Auf dem iPhone kann eine Website nicht automatisch ohne Bestätigung auf den Home-Bildschirm gelegt werden.</p><ol><li>Unten in Safari auf <strong>Teilen</strong> tippen.</li><li><strong>Zum Home-Bildschirm</strong> wählen.</li><li>Mit <strong>Hinzufügen</strong> bestätigen.</li></ol>';
    } else {
      text.innerHTML = '<p>Falls dein Browser die direkte Installation nicht anbietet:</p><ol><li>Browser-Menü öffnen.</li><li><strong>App installieren</strong> oder <strong>Zum Startbildschirm hinzufügen</strong> wählen.</li><li>Bestätigen.</li></ol>';
    }
    sheet.classList.add('is-open');
    sheet.setAttribute('aria-hidden','false');
  }
  async function handleInstallClick() {
    if (standalone) return;
    if (pendingInstall) {
      var event = pendingInstall;
      pendingInstall = null;
      await event.prompt();
      var choice = await event.userChoice;
      if (choice && choice.outcome === 'accepted') {
        dismissInstallCta();
      }
      return;
    }
    openInstallSheet();
  }
  function mountMobileInstallCta() {
    if (standalone || installCtaDismissed() || !isMobileViewport || location.pathname !== cfg.start || document.getElementById('scdjk-mobile-install-cta')) return;
    var wrap = document.createElement('div');
    wrap.id = 'scdjk-mobile-install-cta';
    wrap.className = 'page-width';
    wrap.innerHTML = '<button type="button" class="scdjk-mobile-install-button"><span class="scdjk-mobile-install-icon" aria-hidden="true">↓</span><span><strong>APP INSTALLIEREN</strong><small>SC DJK Handball auf dem Home-Bildschirm</small></span></button>';
    wrap.querySelector('button').addEventListener('click', handleInstallClick);
    var hero = document.querySelector('.scdjk-fanshop');
    if (hero) hero.insertAdjacentElement('afterend', wrap);
    else {
      var main = document.getElementById('MainContent');
      if (main) main.insertAdjacentElement('afterbegin', wrap);
    }
  }
  function mount() {
    var header = document.querySelector('.header');
    if (!header) return;
    if (cfg.cart) {
      root.classList.add('mf-handball-fanshop');
      try { sessionStorage.setItem('merchfieber_fanshop', 'handball'); } catch (e) {}
      var brand = header.querySelector('.header__heading-link');
      if (brand) {
        brand.href = url(cfg.start);
        brand.setAttribute('aria-label', 'SC DJK Everswinkel Handball');
        var wrapper = brand.querySelector('.header__heading-logo-wrapper'); if (wrapper) wrapper.style.display = 'none';
        if (!brand.querySelector('.fanshop-isolation-logo')) {
          var logo = document.createElement('img');
          logo.src = 'https://cdn.shopify.com/s/files/1/0973/4835/4395/files/scdjk-handball-logo-white.png?v=1789404808';
          logo.alt = 'SC DJK Everswinkel Handball'; logo.className = 'fanshop-isolation-logo'; brand.appendChild(logo);
        }
      }
    }
    var items = [
      ['START', url(cfg.start)],
      ['TICKER', url(cfg.start, 'handball-ticker')],
      ['MANNSCHAFTEN', url(cfg.start, 'handball-mannschaften')],
      ['FANSHOP', url(cfg.start, 'scdjk-merch')],
      ['BENACHRICHTIGUNGEN', url(cfg.start, 'handball-benachrichtigungen')],
      ['WARENKORB', url(cfg.cartUrl)]
    ];
    document.querySelectorAll('.header__inline-menu > ul, #menu-drawer .menu-drawer__navigation > .menu-drawer__menu').forEach(function (menu) {
      if (menu.dataset.scdjkAppMenu) return;
      menu.dataset.scdjkAppMenu = 'true';
      menu.querySelectorAll('[data-scdjk-handballticker], a[href="/"]').forEach(function (link) { var li = link.closest('li'); if (li) li.remove(); });
      items.slice().reverse().forEach(function (item) {
        var li = document.createElement('li'); var link = document.createElement('a');
        link.href = item[1]; link.textContent = item[0]; link.dataset.scdjkAppNav = 'true';
        link.className = menu.closest('#menu-drawer') ? 'menu-drawer__menu-item list-menu__item link link--text focus-inset' : 'header__menu-item list-menu__item link link--text focus-inset';
        li.appendChild(link); menu.prepend(li);
      });
    });
    var brandLink = header.querySelector('.header__heading-link'); if (brandLink) brandLink.href = url(cfg.start);
    mountMobileInstallCta();
    if (location.hash === '#handball-benachrichtigungen') window.setTimeout(openNotifyPanel, 0);
    var style = document.getElementById('scdjk-app-style');
    if (!style) {
      style = document.createElement('style'); style.id = 'scdjk-app-style';
      style.textContent = '.scdjk-app-active #scdjk-app-install-help{padding-top:18px;padding-bottom:18px;font-size:14px}.scdjk-app-active #scdjk-app-install-help summary{cursor:pointer}.scdjk-app-active #scdjk-app-install-help p{max-width:760px}.scdjk-app-active .header__inline-menu{display:block!important}.scdjk-app-active .header__inline-menu>ul{flex-wrap:wrap}.scdjk-app-active .header__menu-item{font-size:12px}.scdjk-app-standalone .header{padding-top:max(6px,env(safe-area-inset-top))!important}.scdjk-app-standalone body{padding-bottom:env(safe-area-inset-bottom)}html.scdjk-app-active{padding-bottom:0!important}html.scdjk-app-active #preview-bar-iframe,html.scdjk-app-active .shopify-preview-bar,html.scdjk-app-active #PBarNextFrameWrapper,html.scdjk-app-active #admin-bar-iframe{display:none!important;visibility:hidden!important;height:0!important;min-height:0!important;max-height:0!important}#scdjk-notify-modal{position:fixed;inset:0;z-index:2147482500;display:none}#scdjk-notify-modal.is-open{display:block}.scdjk-notify-backdrop{position:absolute;inset:0;background:rgba(0,0,0,.72);backdrop-filter:blur(5px)}.scdjk-notify-card{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:min(92vw,760px);max-height:88vh;overflow:auto;background:#111;color:#fff;border:1px solid rgba(255,255,255,.12);border-radius:24px;padding:28px;box-shadow:0 25px 80px rgba(0,0,0,.5)}.scdjk-notify-close{position:absolute;right:14px;top:10px;border:0;background:transparent;color:#fff;font-size:34px;line-height:1;cursor:pointer}.scdjk-notify-kicker{margin:0 0 6px;color:#e31c23;font-size:12px;font-weight:800;letter-spacing:.22em}.scdjk-notify-card h2{margin:0 0 8px;color:#fff}.scdjk-notify-note,.scdjk-notify-status{color:rgba(255,255,255,.72);font-size:14px}.scdjk-notify-grid{display:grid;grid-template-columns:1fr 1fr;gap:22px;margin-top:22px}.scdjk-notify-card fieldset{border:1px solid rgba(255,255,255,.12);border-radius:16px;padding:16px}.scdjk-notify-card legend{padding:0 8px;font-weight:800;color:#fff}.scdjk-notify-options{display:grid;gap:9px}.scdjk-notify-options label,.scdjk-notify-extra>label{display:flex;align-items:center;gap:10px;color:#fff;font-size:14px}.scdjk-notify-options input,.scdjk-notify-extra input[type=checkbox]{width:20px;height:20px;accent-color:#B02324}.scdjk-notify-extra{display:grid;gap:12px;margin:20px 0}.scdjk-quiet-times{display:flex;gap:12px;flex-wrap:wrap}.scdjk-quiet-times label{color:rgba(255,255,255,.8);font-size:13px}.scdjk-quiet-times input{margin-left:6px;background:#1c1c1c;color:#fff;border:1px solid rgba(255,255,255,.2);border-radius:8px;padding:6px}.scdjk-notify-done{width:100%;margin-top:8px}.scdjk-notify-open{overflow:hidden}#scdjk-mobile-install-cta{display:none;padding-top:14px;padding-bottom:14px}#scdjk-mobile-install-cta[hidden]{display:none!important}.scdjk-mobile-install-button{width:100%;border:0;border-radius:16px;background:linear-gradient(135deg,#B02324,#e31c23);color:#fff;display:flex;align-items:center;justify-content:center;gap:14px;padding:15px 18px;box-shadow:0 10px 26px rgba(176,35,36,.25);font:inherit;cursor:pointer}.scdjk-mobile-install-icon{display:grid;place-items:center;width:36px;height:36px;border-radius:50%;background:rgba(255,255,255,.16);font-size:24px;font-weight:700;line-height:1}.scdjk-mobile-install-button span:last-child{display:flex;flex-direction:column;align-items:flex-start;text-align:left}.scdjk-mobile-install-button strong{font-size:14px;letter-spacing:.08em}.scdjk-mobile-install-button small{margin-top:2px;font-size:11px;font-weight:400;color:rgba(255,255,255,.82)}#scdjk-install-sheet{position:fixed;inset:0;z-index:2147482600;display:none}#scdjk-install-sheet.is-open{display:block}.scdjk-install-sheet-backdrop{position:absolute;inset:0;background:rgba(0,0,0,.72);backdrop-filter:blur(5px)}.scdjk-install-sheet-card{position:absolute;left:50%;bottom:max(18px,env(safe-area-inset-bottom));transform:translateX(-50%);width:min(92vw,520px);background:#111;color:#fff;border:1px solid rgba(255,255,255,.13);border-radius:24px;padding:24px 22px;box-shadow:0 24px 70px rgba(0,0,0,.5)}.scdjk-install-sheet-close{position:absolute;right:14px;top:10px;border:0;background:transparent;color:#fff;font-size:32px;cursor:pointer}.scdjk-install-sheet-icon{font-size:38px;margin-bottom:8px}.scdjk-install-sheet-card h2{margin:0 34px 8px 0;color:#fff;font-size:22px}.scdjk-install-sheet-card p,.scdjk-install-sheet-card li{font-size:14px;line-height:1.5;color:rgba(255,255,255,.82)}.scdjk-install-sheet-card ol{padding-left:20px}.scdjk-install-sheet-done{width:100%;margin-top:8px}@media(max-width:989px){#scdjk-mobile-install-cta{display:block}}@media(max-width:640px){.scdjk-notify-card{width:94vw;padding:22px 18px;border-radius:20px}.scdjk-notify-grid{grid-template-columns:1fr;gap:14px}}@media(max-width:989px){.scdjk-app-active header-drawer{display:block!important}.scdjk-app-active .header__inline-menu{display:none!important}}';
      document.head.appendChild(style);
    }
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[data-scdjk-app-nav]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    var target = new URL(link.href);
    if (target.hash === '#handball-benachrichtigungen') {
      event.preventDefault();
      openNotifyPanel();
      return;
    }
    if (target.pathname === location.pathname && /^#handball-(ticker|mannschaften)$/.test(target.hash)) {
      event.preventDefault();
      document.dispatchEvent(new CustomEvent('scdjk:app-ticker', {detail:{team:target.hash === '#handball-mannschaften'}}));
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();
